<template>
    <div class="sidebar-left">
        <legenda />
        <total />
        <!-- <longa-permanencia /> -->
        <covid19 />
        <vinte-quatro v-if="unidadeSelecionada.tipo == 5" />
        <acompanhamento />
        <plantao />
        <excel />
        <validar />
        <relacao-leitos />    
        <info-valida />
    </div>
</template>

<script>
import Legenda from './legenda/Legenda.vue'
import Total from './total/Total.vue'
// import LongaPermanencia from './longapermanencia/LongaPermanencia.vue'
import Covid19 from './covid19/Covid19.vue'
import VinteQuatro from './vintequatro/VinteQuatro.vue'
import Acompanhamento from './acompanhamento/Acompanhamento.vue'
import Excel from './excel/Excel.vue'
import Validar from './validar/Validar.vue'
import RelacaoLeitos from './relacaoLeitos/RelacaoLeitos.vue'
import InfoValida from './info-valida/InfoValida.vue'
import Plantao from './plantao/Plantao.vue'

export default {
    components: {
        Legenda,
        Total,
        Covid19,
        VinteQuatro,
        Excel,
        Validar,
        RelacaoLeitos,
        InfoValida,
        Acompanhamento,
        Plantao
    },
    computed: {
        unidadeSelecionada () {
            return this.$store.getters['filtro/getUnidadeSelecionada']
        },
    }
}
</script>

<style>
    .sidebar-left {
        flex-basis: 100px;
        order: 1;
    }

    @media (min-width: 1154px) {
        .sidebar-left {
            min-width: 209px;
            flex-basis: 209px;
        }
    }

</style>